module.exports = __webpack_public_path__ + "static/media/resource.700a7fe0.png";